import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const zucaBurguerTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#3ab54b',
    },
    secondary: {
      main: '#ed1720',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#ed1720',
    },
  },
};
